import React, { useEffect, useState } from "react";
import Card from "components/card";
import {
  MdFileDownload,
  MdArrowDropUp,
  MdArrowDropDown,
  MdOutlineContentCopy,
} from "react-icons/md";
import { BiSolidCopy } from "react-icons/bi";
import { FaCheck } from "react-icons/fa6";

import { formatReportData, reportModal, formatLocationsText } from "models/wizard/wizard-modals";
import {
  deleteDataById,
  fetchData,
  sendReportToMail,
  updatetDataById,
} from "api";
import { reports } from "api/collection_names";
import { GeneratePDF } from "components/generatePdf/generatePdf";
import { getUser, saveUser } from "auth/Authentication";
import AppSnackbar from "components/snakbar";
import { SnackbarState } from "models/user-models";
import TextField from "@mui/material/TextField";

import { Autocomplete, Box, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { GridColDef } from "@mui/x-data-grid";
import { MdDelete as DeleteIcon } from "react-icons/md";
import DataTable from "components/Datatable/Datatable";

const Report = () => {
  const [user, setUser] = React.useState(null);
  const [dropDownUsers, setDropDownUsers] = useState<any[]>([]);
  const [reportList, setReportList] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [noReportFound, setNoReportFound] = useState<boolean>(false);
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: "",
    severity: "info",
  });

  // const [rows, setRows] = useState<[]>([])
  const [filteredReports, setFilteredReports] = useState<any[]>([]);
  const [localUser, setLocalUser] = useState(null);
  const [isExpired, setIsExpired] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [strictExpiry, setStrictExpiry] = useState(false);
  const navigate = useNavigate();
  // useEffect(() => {
  //   const isTokenExpired = () => {
  //       const expirationTime = localStorage.getItem('expirationTime');
  //       if (!expirationTime) return true;
  //       return new Date().getTime() > Number(expirationTime);
  //     };
  //     console.log("isTokenExpired++++++",isTokenExpired())

  //     if (isTokenExpired()) {
  //       localStorage.removeItem('expirationTime');
  //    navigate('/auth/sign-in');
  //     }
  // }, [navigate]);

  const [sortedReports, setSortedReports] = useState<any[]>([]);

  const [sortConfig, setSortConfig] = useState<{
    key: string;
    direction: "ascending" | "descending";
  }>({
    key: "",
    direction: "ascending",
  });

  const [page, setPage] = useState(0);
  const rowsPerPage = 10;

  const totalPages = Math.ceil(sortedReports.length / rowsPerPage);

  const fetchReportList = async () => {
    try {
      setLoading(true);
      const user = getUser();
      const res = await fetchData(reports);
      console.log("fetch response: ", res);
      if (res.success) {
        const limitedReports = res.data
          .sort(
            (a: any, b: any) =>
              new Date(b.added_on).getTime() - new Date(a.added_on).getTime()
          )
          .slice(0, 10);
        if (user && user?.type === "1") {
          const data = res.data;
          const updatedData = data.map((report: any, index: number): any => {
            console.log("report: ", report);
            const assessment = report.impressions
              .map((imp: any) => {
                const desc = imp.description || "";
                const scrollDowns =
                  imp.scroll_downs && imp.scroll_downs.length > 0
                    ? imp.scroll_downs.join(", ")
                    : "";

                return scrollDowns ? `${desc} ${scrollDowns}` : desc;
              })
              .join(" | "); // or ", " if you prefer

            return {
              ...report,
              assessment: assessment,
            };
          });

          // console.log("updated data: ", updatedData)
          setReportList(updatedData);
          setSortedReports(updatedData);
          setFilteredReports(updatedData);
        } else {
          let reportList = res?.data?.filter(
            (reports: any) => reports.added_by == user._id
          );
          setReportList(reportList);
          setSortedReports(reportList);
          setFilteredReports(reportList);
        }
      } else {
        alert("No Users Found!");
        navigate("/auth/sign-in");
      }
      setLoading(false);
    } catch (error: any) {
      const alreadyLoggedIn = error.message.endsWith("401");
      if (alreadyLoggedIn) {
        setSnackbar({
          open: true,
          message: "logged in from some other device",
          severity: "error",
        });
        setTimeout(() => {
          navigate("/auth/sign-in");
        }, 3000);
      }
      setLoading(false);
    }
  };

  const handleSort = (key: keyof reportModal | string) => {
    let direction: "ascending" | "descending" = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    const sorted = [...sortedReports].sort((a, b) => {
      const valueA = key.includes(".")
        ? a[key.split(".")[0]][key.split(".")[1]]
        : a[key];
      const valueB = key.includes(".")
        ? b[key.split(".")[0]][key.split(".")[1]]
        : b[key];

      const firstCharA =
        typeof valueA === "string" ? valueA.charAt(0).toLowerCase() : "";
      const firstCharB =
        typeof valueB === "string" ? valueB.charAt(0).toLowerCase() : "";

      if (firstCharA < firstCharB) {
        return direction === "ascending" ? -1 : 1;
      }
      if (firstCharA > firstCharB) {
        return direction === "ascending" ? 1 : -1;
      }
      return 0;
    });

    setSortedReports(sorted);
    setSortConfig({ key, direction });
  };

  const handleSortByDate = () => {
    let direction: "ascending" | "descending" = "ascending";

    if (sortConfig.key === "date" && sortConfig.direction === "ascending") {
      direction = "descending";
    }

    const sorted = [...sortedReports].sort((a, b) => {
      const dateA = new Date(a.added_on);
      const dateB = new Date(b.added_on);
      return direction === "ascending"
        ? dateA.getTime() - dateB.getTime()
        : dateB.getTime() - dateA.getTime();
    });

    setSortedReports(sorted);
    setSortConfig({ key: "date", direction });
  };

  function handleReportView(report: reportModal) {
    const printWindow = window.open("", "_blank");

    if (report.examinations && report.examinations.length > 0) {
      const vitalsOrder = [
        "Temperature",
        "Blood Pressure",
        "Heart Rate",
        "Height & Weight",
        "Body Mass Index",
      ];
      report.examinations.sort((a, b) => {
        const aIsVital = vitalsOrder.includes(a.description);
        const bIsVital = vitalsOrder.includes(b.description);
        if (aIsVital && !bIsVital) return -1;
        if (!aIsVital && bIsVital) return 1;

        const aHasId = "_id" in a && a._id;
        const bHasId = "_id" in b && b._id;
        return aHasId ? 1 : bHasId ? -1 : 0;
      });
    }

    const getScrollDownsText = (scrollDowns: any) => {
      if (!scrollDowns || scrollDowns.length === 0) return "";
      return scrollDowns.map((sd: any) => sd.description || sd).join(", ");
    };

    printWindow?.document.write(`
        <html>
        <head>
          <title>Medical Note</title>
          <style>
            body {
              font-family: 'DM Sans', Arial, sans-serif;
              margin: 40px;
              color: #333;
              line-height: 1.5;
            }
            .header {
              text-align: center;
              margin-bottom: 30px;
              border-bottom: 2px solid #333;
              padding-bottom: 10px;
            }
            .header h1 {
              margin: 0;
              font-size: 24px;
              font-weight: 600;
            }
            .section {
              margin-bottom: 20px;
            }
            .section-title {
              font-size: 18px;
              font-weight: 600;
              color: #1a1a1a;
              margin-bottom: 8px;
              margin-top: 15px;
              border-bottom: 1px solid #ddd;
              padding-bottom: 5px;
            }
            .section-content {
              margin-left: 0px;
              font-size: 14px;
              line-height: 1.6;
            }
            .content-item {
              margin-bottom: 6px;
              display: block;
            }
            .content-item span {
              display: inline;
            }
            .location-label {
              font-weight: 500;
            }
            .duration-text {
              display: inline;
            }
            .remark {

              display: block;
            }
            .examination-item {
              margin-bottom: 6px;
            }
            .examination-value {
              color: #666;
            }
            .bullet-item {
              margin-left: 20px;
              margin-bottom: 4px;
            }
            @media print {
              body {
                margin: 20px;
              }
            }
          </style>
        </head>
        <body>
          <div class="header">
            <h1>Medical Note</h1>
          </div>
    
          ${(report.complaints && report.complaints.length > 0) ||
        report.complaintRemark
        ? `
          <div class="section">
            <div class="section-title">MAIN COMPLAINT</div>
            <div class="section-content">
              ${report.complaints && report.complaints.length > 0
          ? report.complaints
            .map((complaint) => {
              let html = `<div class="content-item"><span class="font-medium">${complaint.description}</span>`;

              if (
                complaint.scroll_downs &&
                complaint.scroll_downs.length > 0
              ) {
                html += ` <span>${complaint.scroll_downs.join(
                  ", "
                )}</span>`;
              }

              if (report.duration && report.durationType) {
                html += `<br/><span class="duration-text">since ${report.duration
                  } ${report.duration != 1
                    ? report.durationType.slice(-1) === "s"
                      ? report.durationType
                      : report.durationType + "s"
                    : report.durationType.slice(-1) === "s"
                      ? report.durationType.slice(0, -1)
                      : report.durationType
                  }</span>`;
              }
              html += `</div>`;
              return html;
            })
            .join("")
          : ""
        }
              ${Array.isArray(report.complaintLocation) &&
          report.complaintLocation.length > 0 &&
          Boolean(formatLocationsText(report.complaintLocation))
          ? `<div class="content-item"><span class="location-label">Location: ${formatLocationsText(
            report.complaintLocation
          )}</span></div>`
          : ""
        }
              ${report.complaintRemark
          ? `<div class="remark">${report.complaintRemark}</div>`
          : ""
        }
            </div>
          </div>
        `
        : ""
      }
    
          ${(report.otherSymptoms && report.otherSymptoms.length > 0) ||
        report.otherSymptomRemark
        ? `
          <div class="section">
            <div class="section-content">
              ${report.otherSymptoms && report.otherSymptoms.length > 0
          ? report.otherSymptoms
            .map((os) => {
              let html = `<div class="content-item"><span>${os.description}</span>`;

              if (os.scroll_downs && os.scroll_downs.length > 0) {
                html += ` <span>${os.scroll_downs.join(", ")}</span>`;
              }

              html += `</div>`;
              return html;
            })
            .join("")
          : ""
        }
              ${report.otherSymptoms &&
          report.otherSymptoms.length > 0 &&
          report.otherSymptomDuration &&
          report.otherSymptomDurationType
          ? `<div class="content-item"><span class="duration-text">since ${report.otherSymptomDuration
          } ${report.otherSymptomDuration != 1
            ? report.otherSymptomDurationType.slice(-1) === "s"
              ? report.otherSymptomDurationType
              : report.otherSymptomDurationType + "s"
            : report.otherSymptomDurationType.slice(-1) === "s"
              ? report.otherSymptomDurationType.slice(0, -1)
              : report.otherSymptomDurationType
          }</span></div>`
          : ""
        }
              ${report.otherSymptoms &&
          report.otherSymptoms.length > 0 &&
          Array.isArray(report.otherSymptomLocation) &&
          report.otherSymptomLocation.length > 0 &&
          Boolean(formatLocationsText(report.otherSymptomLocation))
          ? `<div class="content-item"><span class="location-label">Location: ${formatLocationsText(
            report.otherSymptomLocation
          )}</span></div>`
          : ""
        }
              ${report.otherSymptomRemark
          ? `<div class="remark">${report.otherSymptomRemark}</div>`
          : ""
        }
            </div>
          </div>
        `
        : ""
      }
    
          ${(report.history && report.history.length > 0) ||
        report.historyRemark
        ? `
          <div class="section">
            <div class="section-title">HISTORY</div>
            <div class="section-content">
              ${report.history && report.history.length > 0
          ? report.history
            .map((item) => {
              let html = `<div class="content-item"><span>${item.description}</span>`;

              if (item.scroll_downs && item.scroll_downs.length > 0) {
                html += ` <span>${item.scroll_downs.join(
                  ", "
                )}</span>`;
              }

              html += `</div>`;
              return html;
            })
            .join("")
          : ""
        }
              ${report.history &&
          report.history.length > 0 &&
          report.historyDuration &&
          report.historyDurationType
          ? `<div class="content-item"><span class="duration-text">since ${report.historyDuration
          } ${report.historyDuration != 1
            ? report.historyDurationType.slice(-1) === "s"
              ? report.historyDurationType
              : report.historyDurationType + "s"
            : report.historyDurationType.slice(-1) === "s"
              ? report.historyDurationType.slice(0, -1)
              : report.historyDurationType
          }</span></div>`
          : ""
        }
              ${report.historyRemark
          ? `<div class="remark">${report.historyRemark}</div>`
          : ""
        }
            </div>
          </div>
        `
        : ""
      }
    
          ${(report.examinations && report.examinations.length > 0) ||
        report.examinationRemark
        ? `
          <div class="section">
            <div class="section-title">ON EXAMINATION</div>
            <div class="section-content">
              ${report.examinations && report.examinations.length > 0
          ? report.examinations
            .map((item: any) => {
              let examinationText = "";

              if (item.description !== "Height & Weight") {
                examinationText = `${item.description}`;
              }

              let weightKG = item.value?.find(
                (x: any) => x.unitValue === "Kilos"
              );
              let weightPounds = item.value?.find(
                (x: any) => x.unitValue === "Pounds"
              );
              let heightCM = item.value?.find(
                (x: any) => x.unitValue === "Centimeters"
              );
              let heightFeets = item.value?.find(
                (x: any) => x.unitValue === "Feets"
              );
              let heightInches = item.value?.find(
                (x: any) => x.unitValue === "Inches"
              );

              if (weightKG) {
                examinationText = `Height: ${heightCM?.inputValue} centimeters, Weight: ${weightKG?.inputValue} kilos`;
              }

              if (weightPounds) {
                examinationText = `Height: ${heightFeets?.inputValue} feets ${heightInches?.inputValue} inches, Weight: ${weightPounds?.inputValue} pounds`;
              }

              if (
                !weightKG &&
                !weightPounds &&
                item?.value &&
                item.value.length > 0 &&
                item.value[0]
              ) {
                examinationText += `: ${item.value[0].inputValue
                  ? item.value[0].inputValue
                  : ""
                  } ${item.value[0].unitValue
                    ? item.value[0].unitValue
                    : ""
                  }`.trim();
              }

              if (item.scroll_downs && item.scroll_downs.length > 0) {
                examinationText += ` ${getScrollDownsText(
                  item.scroll_downs
                )}`;
              }

              return `<div class="examination-item">${examinationText}</div>`;
            })
            .join("")
          : ""
        }
              ${Array.isArray(report.examinationLocation) &&
          report.examinationLocation.length > 0 &&
          Boolean(formatLocationsText(report.examinationLocation))
          ? `<div class="content-item"><span class="location-label">Location: ${formatLocationsText(
            report.examinationLocation
          )}</span></div>`
          : ""
        }
              ${report.examinationRemark
          ? `<div class="remark">${report.examinationRemark}</div>`
          : ""
        }
            </div>
          </div>
        `
        : ""
      }
    
          ${(report.impressions && report.impressions.length > 0) ||
        report.impressionRemark ||
        (Array.isArray(report.impressionLocation || report.assessmentLocation) &&
          (report.impressionLocation || report.assessmentLocation).length > 0)
        ? `
          <div class="section">
            <div class="section-title">ASSESMENT</div>
            <div class="section-content">
              ${report.impressions && report.impressions.length > 0
          ? report.impressions
            .map((item) => {
              let html = `<div class="content-item"><span>${item.description}</span>`;

              if (item.scroll_downs && item.scroll_downs.length > 0) {
                html += ` <span>${item.scroll_downs.join(
                  ", "
                )}</span>`;
              }

              html += `</div>`;
              return html;
            })
            .join("")
          : ""
        }
              ${Array.isArray(report.impressionLocation || report.assessmentLocation) &&
          (report.impressionLocation || report.assessmentLocation).length > 0 &&
          Boolean(formatLocationsText(report.impressionLocation || report.assessmentLocation))
          ? `<div class="content-item"><span class="location-label">Location: ${formatLocationsText(
            report.impressionLocation || report.assessmentLocation
          )}</span></div>`
          : ""
        }
              ${report.impressionRemark
          ? `<div class="remark">${report.impressionRemark}</div>`
          : ""
        }
            </div>
          </div>
        `
        : ""
      }
    
          ${(report.treatment_plans && report.treatment_plans.length > 0) ||
        report.treatmentRemark
        ? `
          <div class="section">
            <div class="section-title">PLAN</div>
            <div class="section-content">
              ${report.treatment_plans && report.treatment_plans.length > 0
          ? report.treatment_plans
            .map((item) => {
              let html = `<div class="examination-item"><span>${item.description}</span>`;

              if (item.scroll_downs && item.scroll_downs.length > 0) {
                html += `<div>${item.scroll_downs
                  .map(
                    (scroll) =>
                      `<div class="bullet-item">- ${scroll}</div>`
                  )
                  .join("")}</div>`;
              }

              html += `</div>`;
              return html;
            })
            .join("")
          : ""
        }
              ${report.treatmentRemark
          ? `<div class="remark">${report.treatmentRemark}</div>`
          : ""
        }
            </div>
          </div>
        `
        : ""
      }
        </body>
        </html>
      `);

    printWindow?.focus();
  }

  const hasTrialExpired = (expirationTimeUTC: any) => {
    const currentTimeUTC = new Date().toISOString(); // Get current time in UTC
    return currentTimeUTC > expirationTimeUTC; // Compare current time with expiration time
  };

  async function handleDownloadButton(userReport: reportModal) {
    const user = getUser();
    const hasTrialExpired = (expirationTimeUTC: any) => {
      const currentTimeUTC = new Date().toISOString(); // Get current time in UTC
      return currentTimeUTC > expirationTimeUTC; // Compare current time with expiration time
    };

    if (
      user.type === "2" &&
      !isChecked &&
      hasTrialExpired(user.trial_expiry) &&
      !user.hasOwnProperty("expiryTime")
    ) {
      // setIsChecked(true);
      // alert("Your trial has expired. Please switch to the subscription mode.");
      setSnackbar({
        open: true,
        message:
          "Your trial has expired. Please switch to the subscription mode.",
        severity: "error",
      });
      return;
    }

    if (user.type === "2" && (isExpired || localUser.package_name === null)) {
      // localStorage.setItem("user",JSON.stringify())

      setSnackbar({
        open: true,
        message: "Your trial has ended. Please renew your subscription.",
        severity: "error",
      });
      await updatetDataById(
        "Users",
        {
          package_name: null,
          phone_number: null,
          session_id: null,
          expiryTime: null,
          randomCode: null,
          subscriptionOwnerId: null,
          subscriptionOwner: null,
        },
        localUser._id
      );
      const updatedUser = localUser;

      updatedUser.package_name = null;
      updatedUser.phone_number = null;
      updatedUser.session_id = null;
      updatedUser.expiryTime = null;
      updatedUser.subscription = "inactive";
      updatedUser.subscriptionOwner = false;
      updatedUser.subscriptionOwnerId = null;
      updatedUser.randomCode = null;

      localStorage.setItem("user", JSON.stringify(updatedUser));
      return;
    }
    const assessmentLoc =
      userReport?.impressionLocation ||
      userReport?.assessmentLocation ||
      (userReport as any)?.impression_location ||
      (userReport as any)?.assessment_location;
    const reportPayload = {
      ...userReport,
      impressionLocation: assessmentLoc,
      assessmentLocation: assessmentLoc,
    };
    const pdfBlob = await GeneratePDF(reportPayload);
    const url = URL.createObjectURL(pdfBlob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "note.pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  }

  React.useEffect(() => {
    const userr = getUser();
    const expiredTrial = hasTrialExpired(userr.trial_expiry);
    if (expiredTrial) {
      setStrictExpiry(true);
    }
  }, [navigate]);

  async function handleSendPDFButton(userReport: reportModal) {
    const user = getUser();
    const hasTrialExpired = (expirationTimeUTC: any) => {
      const currentTimeUTC = new Date().toISOString(); // Get current time in UTC
      return currentTimeUTC > expirationTimeUTC; // Compare current time with expiration time
    };

    if (
      user.type === "2" &&
      !isChecked &&
      hasTrialExpired(user.trial_expiry) &&
      !user.hasOwnProperty("expiryTime")
    ) {
      // setIsChecked(true);
      // alert("Your trial has expired. Please switch to the subscription mode.");
      setSnackbar({
        open: true,
        message:
          "Your trial has expired. Please switch to the subscription mode.",
        severity: "error",
      });
      return;
    }

    if (user.type === "2" && (isExpired || localUser.package_name === null)) {
      // localStorage.setItem("user",JSON.stringify())

      setSnackbar({
        open: true,
        message: "Your trial has ended. Please renew your subscription.",
        severity: "error",
      });
      await updatetDataById(
        "Users",
        {
          package_name: null,
          phone_number: null,
          session_id: null,
          expiryTime: null,
          randomCode: null,
          subscriptionOwnerId: null,
          subscriptionOwner: null,
        },
        localUser._id
      );
      const updatedUser = localUser;

      updatedUser.package_name = null;
      updatedUser.phone_number = null;
      updatedUser.session_id = null;
      updatedUser.expiryTime = null;
      updatedUser.subscription = "inactive";
      updatedUser.subscriptionOwner = false;
      updatedUser.subscriptionOwnerId = null;
      updatedUser.randomCode = null;

      localStorage.setItem("user", JSON.stringify(updatedUser));
      return;
    }
    // const user = getUser();
    if (user) {
      const assessmentLoc =
        userReport?.impressionLocation ||
        userReport?.assessmentLocation ||
        (userReport as any)?.impression_location ||
        (userReport as any)?.assessment_location;
      const reportPayload = {
        ...userReport,
        impressionLocation: assessmentLoc,
        assessmentLocation: assessmentLoc,
      };
      const pdfBlob = await GeneratePDF(reportPayload);
      const file = new File([pdfBlob], "note.pdf", {
        type: pdfBlob.type,
        lastModified: new Date().getTime(),
      });
      const formData = new FormData();
      formData.append("email", user.email);
      formData.append("file", file);
      try {
        const res = await sendReportToMail(formData);
        if (res.success) {
          setSnackbar({
            open: true,
            message: "Email sent successfully",
            severity: "success",
          });
        } else {
          setSnackbar({
            open: true,
            message: "Error sending email",
            severity: "error",
          });
        }
      } catch (error) {
        console.error("Error uploading file:", error);
      }
    }
  }

  useEffect(() => {
    fetchReportList();
    const updateUser = async () => {
      // localStorage.removeItem('user');
      const currentUser = getUser();
      const user = await fetchData("Users");

      const matchedUser = user.data.filter((e: any) => {
        return e.email === currentUser.email;
      });

      saveUser(matchedUser);
    };
    // updateUser()
  }, []);

  useEffect(() => {
    setSortedReports(filteredReports);
  }, [filteredReports]);

  useEffect(() => {
    let local_user = getUser();
    setUser(local_user.type);
  }, []);

  useEffect(() => {
    try {
      fetchData("Users")
        .then((res) => {
          setDropDownUsers(res.data);
        })
        .catch((e) => console.log(e));
    } catch (error: any) {
      const alreadyLoggedIn = error.message.endsWith("401");
      if (alreadyLoggedIn) {
        setSnackbar({
          open: true,
          message: "logged in from some other device",
          severity: "error",
        });
        setTimeout(() => {
          navigate("/auth/sign-in");
        }, 3000);
      }
    }
  }, []);

  useEffect(() => {
    const fetchUser = async () => {
      const user = await getUser(); // Fetch or retrieve the user explicitly

      setLocalUser(user);
      if (user && user.expiryTime) {
        const expirationDate = new Date(user.expiryTime); // Convert to Date
        const currentDate = new Date(); // Current date

        if (currentDate > expirationDate) {
          setIsExpired(true);
          // Redirect or notify the user
        } else {
          setIsExpired(false);
          // Allow user to continue
        }
      } else {
      }
    };

    fetchUser();
  }, [navigate]); // Only include `navigate` if necessary

  const allOption = { _id: "all", email: "All" };
  const options = [allOption, ...dropDownUsers];
  const [selectedUser, setSelectedUser] = useState(allOption);

  const [selectedNotes, setSelectedNotes] = useState<string[]>([]);
  const [textCopied, setTextCopied] = React.useState(false);
  const [copiedRowId, setCopiedRowId] = useState(null);

  const handleCopyToClipboard = async (params: any) => {
    const userReport = params.row.report;
    try {
      const report = {
        ...userReport,
        duration: userReport.duration,
        durationType: userReport.durationType,
        complaintRemark: userReport.complaintRemark,
        complaintLocation: userReport.complaintLocation,
        subComplaintRemark: userReport.subComplaintRemark,
        impressionRemark: userReport.impressionRemark,
        examinationRemark: userReport.examinationRemark,
        treatmentRemark: userReport.treatmentRemark,
        otherSymptomRemark: userReport.otherSymptomRemark,
        otherSymptomDuration: userReport.otherSymptomDuration,
        otherSymptomDurationType: userReport.otherSymptomDurationType,
        otherSymptomLocation: userReport.otherSymptomLocation,
        examinationLocation: userReport.examinationLocation,
        impressionLocation: userReport.impressionLocation || userReport.assessmentLocation,
        historyRemark: userReport.historyRemark,
        historyDuration: userReport.historyDuration,
        historyDurationType: userReport.historyDurationType,
      };
      const formattedData = formatReportData(report);
      await navigator.clipboard.writeText(formattedData);
      setCopiedRowId(params.row._id);
      setTimeout(() => {
        setCopiedRowId(null);
      }, 5000);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const rows: any = sortedReports.map((report, index) => {
    // Build assessment text: impressions + their scroll-downs
    const impressionText =
      report.impressions && report.impressions.length > 0
        ? report.impressions
          .map((imp: any) => {
            const desc = imp.description || "";
            const scrollDowns =
              imp.scroll_downs && imp.scroll_downs.length > 0
                ? imp.scroll_downs.join(", ")
                : "";
            return scrollDowns ? `${desc} ${scrollDowns}` : desc;
          })
          .join(" | ")
        : "";

    // Build location text from impressionLocation / assessmentLocation
    const impLoc =
      report.impressionLocation ||
      report.assessmentLocation ||
      report.assessment_location ||
      [];
    const locationText =
      Array.isArray(impLoc) && impLoc.length > 0
        ? formatLocationsText(impLoc)
        : "";

    // Build remark text for assessment
    const remarkText = (
      report.impressionRemark ||
      report.impression_remark ||
      report.assessmentRemark ||
      report.assessment_remark ||
      ""
    ).trim();

    const baseAssessment = impressionText || report.assessment || "";

    // Combine: "Impression A | Impression B — Location: loc1, loc2 — Remark: ..."
    const parts: string[] = [];
    if (baseAssessment) parts.push(baseAssessment);
    if (locationText) parts.push(`Location: ${locationText}`);
    if (remarkText) parts.push(`Remark: ${remarkText}`);
    const combinedAssessment = parts.join(" — ");

    return {
      _id: report._id,
      description: report.system?.description || "",
      added_on: report.added_on,
      assessment: combinedAssessment || baseAssessment,
      assessmentFull: combinedAssessment || baseAssessment,
      impressionText: baseAssessment,
      locationText,
      remarkText,
      report: report,
    };
  });
  useEffect(() => {
    console.log("sorted reports: ", sortedReports);
    console.log("notes: ", rows);
  }, [rows, sortedReports]);

  const columns: GridColDef[] = [
    {
      field: "description",
      headerName: "Note",
      width: 300,
      flex: 4,
      disableColumnMenu: true,
      getApplyQuickFilterFn: (value: string) => {
        if (!value || !value.trim()) return null;
        const searchValue = value.trim().toLowerCase();
        return (params: any) => {
          const val = (params?.value || "").toString().toLowerCase();
          return val.includes(searchValue);
        };
      },
      renderCell: (params) => (
        <div
          onClick={() => handleRowClick(params.row?.report)}
          className="cursor-pointer py-1"
          style={{
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflowWrap: "break-word",
            lineHeight: 1.4,
          }}
        >
          {params.value}
        </div>
      ),
    },
    {
      field: "assessment",
      headerName: "Assessment",
      flex: 4,
      getApplyQuickFilterFn: (value: string) => {
        if (!value || !value.trim()) return null;
        const searchValue = value.trim().toLowerCase();
        return (params: any) => {
          // Search across the full combined assessment+location+remark text
          const combined = (
            params?.row?.assessmentFull ||
            params?.row?.remarkText ||
            params?.row?.report?.assessment ||
            params?.row?.report?.impressionRemark ||
            params?.value ||
            ""
          )
            .toString()
            .toLowerCase();
          return combined.includes(searchValue);
        };
      },
      renderCell: (params) => {
        const impression =
          params.row.impressionText ||
          params.row.assessment ||
          params.row.report?.assessment ||
          "";
        const location = params.row.locationText;
        const remark =
          params.row.remarkText ||
          params.row.report?.impressionRemark ||
          params.row.report?.assessmentRemark ||
          "";

        return (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              overflowWrap: "break-word",
              lineHeight: 1.4,
              paddingTop: "6px",
              paddingBottom: "6px",
              width: "100%",
            }}
            onClick={() => handleRowClick(params.row?.report)}
            className="cursor-pointer"
          >
            {impression ? (
              <div className="text-textPrimary">{impression}</div>
            ) : null}
            {location ? (
              <div className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                <span className="font-semibold">Location: </span>
                {location}
              </div>
            ) : null}
            {remark ? (
              <div className="text-xs text-gray-600 dark:text-gray-300 mt-0.5 italic">
                <span className="font-semibold not-italic">Remark: </span>
                {remark}
              </div>
            ) : null}
            {!impression && !location && !remark && (
              <div>{params.row.assessmentFull || params.value || ""}</div>
            )}
          </div>
        );
      },
    },
    {
      field: "added_on",
      headerName: "Date",
      width: 300,
      flex: 2,
      disableColumnMenu: true,
      getApplyQuickFilterFn: () => null,
      valueGetter: (params) =>
        new Date(params.row.added_on).toLocaleDateString(),
    },
    {
      field: "actions",
      headerName: "Action",
      width: 300,
      flex: 2,
      sortable: false,
      disableColumnMenu: true,
      getApplyQuickFilterFn: () => null,
      renderCell: (params: any) => {
        return (
          <div className="flex items-center gap-2">
            <Button
              title="Copy to clipboard"
              sx={{
                width: "30px",
                height: "30px",
                minWidth: "30px",
                mr: "5px",
                padding: 0,
                background: "var(--color-copy-btn-surface, #16A34A)",
                color: "var(--color-copy-btn-icon, white)",
                "&:hover": { background: "var(--color-copy-btn-surface, #16A34A)", opacity: 0.8 },
                "&:active": { background: "var(--color-copy-btn-surface, #16A34A)", opacity: 0.7 },
              }}
              variant="contained"
              onClick={async () => {
                await handleCopyToClipboard(params);
              }}
            >
              {copiedRowId === params.row._id ? <FaCheck /> : <BiSolidCopy />}
            </Button>

            <Button
              title="Download"
              sx={{
                width: "30px",
                height: "30px",
                minWidth: "30px",
                mr: "5px",
                padding: 0,
                background: "var(--color-download-btn-surface, #6495ED)",
                color: "var(--color-download-btn-icon, white)",
                "&:hover": { background: "var(--color-download-btn-surface, #6495ED)", opacity: 0.8 },
                "&:active": { background: "var(--color-download-btn-surface, #6495ED)", opacity: 0.7 },
              }}
              variant="contained"
              onClick={async () => {
                handleDownloadButton(params.row.report);
              }}
            >
              <MdFileDownload />
            </Button>

            {/* <button onClick={() => handleSendPDFButton(params.row.report)} className="text-xl text-[#ADB5BD]">
          <MdMail />
        </button> */}

            <Button
              title="Delete"
              sx={{
                width: "30px",
                height: "30px",
                minWidth: "30px",
                mr: "5px",
                padding: 0,
                background: "#ff0000",
                color: "white",
                "&:hover": { background: "#ff0000", opacity: 0.8 },
                "&:active": { background: "#ff0000", opacity: 0.7 },
              }}
              variant="contained"
              onClick={async () => {
                /* eslint-disable no-restricted-globals */
                if (
                  confirm(`Are you sure to delete ${params.row.description}`)
                ) {
                  const res = await deleteDataById(reports, params.row._id);
                  if (res.success) {
                    fetchReportList();
                    setUser(null);
                  } else {
                    alert(res.message);
                  }
                }
              }}
            >
              <DeleteIcon fontSize="small" />
            </Button>
          </div>
        );
      },
    },
  ];

  const handleSelectChange = (e: any, selectedUser: any) => {
    // const selectedUser = e.target.value;

    setSelectedUser(selectedUser);
    if (selectedUser) {
      setNoReportFound(false);
      if (selectedUser._id !== "all") {
        let specificUserReport = reportList.filter((e, i) => {
          return selectedUser._id === e.added_by;
        });

        if (specificUserReport.length < 1) {
          setNoReportFound(true);
        }
        setFilteredReports(specificUserReport);
        setSortedReports(specificUserReport);
      } else {
        setFilteredReports(reportList);
        setSortedReports(reportList);
      }
    } else {
      setFilteredReports(reportList);
      setSortedReports(reportList);
    }
  };

  const handleRowClick = (report: any) => {
    handleReportView(report);
  };

  const reloadData = async () => {
    setLoading(true);
    await fetchReportList();
    setLoading(false);
  };

  return (
    <>
      {!loading ? (
        <Card extra={"w-full h-full sm:overflow-auto px-8 mt-5"}>
          {/* <div className="overflow-auto h-[700px]"> */}
          {user === "1" ? (
            <div className="mb-2 flex w-full items-center justify-between">
              <header className="py-5">
                <h1 className="text-textPrimary text-[26px] font-semibold">Notes</h1>
              </header>

              <Box display="flex" justifyContent="end">
                <Box className="mt-4 w-full max-w-[300px] px-[32px] md:w-72">
                  <Autocomplete
                    disablePortal
                    id="combo-box-demo"
                    options={options}
                    value={selectedUser}
                    onChange={handleSelectChange}
                    getOptionLabel={(option) => `${option.email}`}
                    sx={{ width: "100%", maxWidth: 300 }}
                    renderInput={(params) => (
                      <TextField {...params} label="Select User" />
                    )}
                  />
                </Box>
              </Box>
            </div>
          ) : (
            ""
          )}
          <div>
            <DataTable
              columns={columns}
              rows={rows}
              loading={loading}
              deleteMultiple={true}
              collection={reports}
              reload={reloadData}
              getRowHeight={() => "auto"}
            />
          </div>
          {/* </div> */}
        </Card>
      ) : (
        <div className="flex min-h-screen items-center justify-center">
          <div className="h-10 w-10 animate-spin rounded-full border-4 border-dashed border-brand-500"></div>
          <div className="text-textPrimary ml-2 text-[18px] font-semibold">
            Just a moment, getting things ready...
          </div>
        </div>
      )}
      <AppSnackbar
        isOpen={snackbar.open}
        title={snackbar.message}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
        severity={snackbar.severity}
      />
    </>
  );
};

export default Report;
